// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"89":"881d2f56","125":"e2b11cfc","288":"9d35c5d0","479":"b143ce19","695":"d208948f","756":"44f84b22"}[chunkId] + ".css";
};